<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-2 px-md-4">
      <button class="btn btn-danger mx-2 my-2" @click="retroceder">
        <i class="bi bi-skip-backward"></i>
      </button>

      <div class="border border-1 rounded-3 p-3 mb-3">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-folder-plus display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              ETAPA DE DOCUMENTOS
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">DATOS GENERALES</p>
          </div>
        </div>
      </div>

      <!-- documento -->



       <b-modal id="modal-verificacion" title="AUTORIZACIÓN DE VERIFICACIÓN" size="lg" scrollable hide-footer>
        <div id="pdf-content" ref="documento" class="document-container">
          <div class="header-logo" style="text-align: right">
            <img :src="require(`../../../../assets/Empresas/${idempresa}.png`)" alt="Logo" style="width: 140px" />
          </div>

          <div class="title" style="
              text-align: center;
              font-weight: bold;
              text-decoration: underline;
              margin: 20px 0;
            ">
            AUTORIZACIÓN DE VERIFICACIÓN
          </div>

          <div class="content" style="text-align: justify; font-size: 13px; line-height: 1.6">
            <p>
              Mediante el presente documento yo: <strong>{{ nombre }}</strong>, de Nacionalidad:
              <strong>{{ nacionalidad }}</strong>, identificado con DNI : <strong>{{ dni }} </strong> autorizo expresamente 
              y en forma irrevocable el descuento por planilla respecto a las verificaciones de antecedentes policiales, 
              penales y judiciales, por el monto de S/. 15.00 soles, el cual se visualizará en la primera boleta de pago.
            </p>

            <br>
            <p>
              <strong>People Outsourcing:</strong> 
            </p>

            <ol class="lista-vulnerabilidad" style="margin-left: 20px">
              <li>Garantiza la confidencialidad y seguridad de los datos proporcionados por el postulante.</li>
              <li>Reconoce y garantiza el derecho del postulante de acceder, aclarar y/o excluir datos que considere 
                de carácter sensible.</li>
              <li>
                Reconoce y garantiza el derecho de las personas de solicitar su eliminación de las bases de datos, al
                 término de cualquier vínculo: laboral, comercial, administrativo, operacional u otro, el que se 
                 realizará observando lo dispuesto en el D.S. 003-2013-JUS Reglamento de la Ley 29733, Ley de Protección
                  de Datos Personales.
              </li>              
            </ol>            

            <p style="margin-top: 30px">
              Miraflores, {{ fechaActual }}
            </p>

               <div class="firma-container d-flex" style="margin-top: 60px;">
                <div class="ms-auto text-center" style="width: 300px;">
                  <p>
                    <strong>
                      {{ nombre }} ( {{ dni }} ) <br /> 
                      Firmado y aceptado digitalmente <br />
                      {{ fechaActual }}
                    </strong>
                  </p>
                </div>
              </div>
          </div>
        </div>
        <div class="text-center">
             <b-button class="mt-3 text-center" variant="success" block @click="descargarPDF('009')" :disabled="loadingVerification">
                <span v-if="loadingVerification">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Cargando...
                </span>
                <span v-else>He leído, comprendo y acepto la autorización de verificación y las responsabilidades legales que implica.</span>
             </b-button>
        </div>
     
      </b-modal>

      <div class="border border-1 pt-2 pb-1 mt-2 mx-2">
        <form action="">
          <p class="text-center text-danger mt-1">{{ docPendiente }}</p>
          <div v-if="permisoVisualizador != 6" class="row gx-2 px-2">
            <!-- <h4
            v-if="documentoEscoger.length > 0"
            class="mt-2 titulo mb-3 text-decoration-underline"
          >
            Documentos:
          </h4> -->

            <div v-show="escoger.parCorrelativo != '004'" v-for="escoger in documentoEscoger" :key="escoger.id"
              class="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="shadow-lg p-3 mb-3 bg-white rounded">
                <div class="text-center tamaño">
                  {{ escoger.parDescripcion }}
                </div>
                <!-- <div  class="input-group">
                  <input type="file" class="form-control my-auto tamaño2" aria-describedby="inputGroupFileAddon04"
                    multiple required aria-label="Upload" @change="onFileSelected" />
                  <button class="btn btn-outline-success py-1" type="button" id="inputGroupFileAddon04"
                    @click="onUpload($event)" :value="escoger.parCorrelativo">
                    cargar
                  </button>
                </div> -->

                <div v-if="escoger.parCorrelativo != '004' && escoger.parCorrelativo != '009'" class="input-group">
                  <input type="file" 
                        class="form-control my-auto tamaño2" 
                        :id="'file-' + escoger.parCorrelativo"
                        multiple required aria-label="Upload" />
                        
                  <button class="btn btn-outline-success py-1" 
                          type="button" 
                          @click="onUpload(escoger.parCorrelativo)">
                    cargar
                  </button>
                </div>



                 <div v-if="escoger.parCorrelativo == '009'">              
                <div  class="text-center">
                 
                    <b-button class="mt-2" @click="$bvModal.show('modal-verificacion')" variant="primary">
                    Ver autorización de verificación
                  </b-button>
                             
                </div>

              </div>



              </div>
            </div>
          </div>
        </form>

        <div class="mx-2">
          <div class="d-flex justify-content-end ms-4 mb-4">
            <label for="" class="mt-4 tamaño2"> Buscar:</label>
            <input class="form-control form-control-lg ms-4 mt-2 tamaño2 tamañofiltrado" type="text"
              placeholder="Tipo de documento" aria-label=".form-control-lg example" v-model="filterField"
              :class="{ 'w-100 mt-3': isMobile, 'w-25': !isMobile }" />
          </div>

          <!-- tabla -->
          <!-- tabla -->
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="bg-solimano-table text-white text-center tamaño2">
                  <th>ID</th>
                  <th scope="col">TIPO DOCUMENTO</th>
                  <th scope="col">DOCUMENTO</th>
                  <th v-if="!isMobile" scope="col">PREVISUALIZACION</th>
                  <th>AUDITORIA</th>
                  <th v-if="
                    permisoVisualizador == 2 ||
                    permisoVisualizador == 10 ||
                    permisoVisualizador == 18
                  ">
                    ELIMINAR
                  </th>
                </tr>
              </thead>

              <!-- SPINNER DE CARGA -->
              <tbody v-if="loading">
                <tr>
                  <td colspan="6" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-muted fw-bold">
                      Cargando documentos...
                    </p>
                  </td>
                </tr>
              </tbody>

              <!-- CUANDO YA CARGO LOS DATOS -->
              <tbody v-else>
                <tr v-for="doc in paginatedDocuments" :key="doc.idDocumento" class="tamaño2 align-middle">
                  <td class="text-center">{{ doc.idDocumento }}</td>

                  <!-- TIPO DOCUMENTO CON ICONO -->
                  <td class="text-center">
                    <i class="bi bi-folder2-open"></i>

                    {{ doc.nomTipoDocumento }}
                  </td>

                  <!-- DESCARGA -->
                  <td class="text-center">
                    <a :href="url + doc.docAdjunto.slice(54)" target="_blank" class="btn btn-success btn-sm me-1"
                      title="Descargar">
                      <i class="bi bi-download"></i>
                    </a>
                  </td>

                  <!-- VISTA PREVIA -->
                  <td v-if="!isMobile" class="text-center">
                    <button class="btn btn-primary btn-sm" @mouseover="
                      doc.docAdjunto.slice(-3) === 'pdf'
                        ? openModal(url + doc.docAdjunto.slice(54))
                        : openModal2(url + doc.docAdjunto.slice(54))
                      " title="Vista previa">
                      <i class="bi bi-eye-fill"></i>
                    </button>

                    <!-- modal pdf -->
                    <div class="modal" v-if="showModal" @mouseout="closeModal">
                      <div class="modal-content">
                        <object :data="currentUrl" type="application/pdf" class="w-100 h-100"></object>
                      </div>
                    </div>

                    <div class="modal" v-if="showModal2" @mouseout="closeModal2">
                      <div class="modal-content">
                        <img :src="currentUrl2" class="w-100 h-100" />
                      </div>
                    </div>
                  </td>

                  <!-- AUDITORIA CON ICONO -->
                  <td class="text-center">
                    <i class="bi bi-person-check-fill" :class="{
                      'text-success': doc.audCrea
                        .toLowerCase()
                        .includes('completo'),
                      'text-warning': doc.audCrea
                        .toLowerCase()
                        .includes('pendiente'),
                      'text-danger': doc.audCrea
                        .toLowerCase()
                        .includes('error'),
                    }"></i>
                    {{ doc.audCrea }}
                  </td>

                  <!-- ELIMINAR -->
                  <td v-if="
                    permisoVisualizador == 2 ||
                    permisoVisualizador == 10 ||
                    permisoVisualizador == 18
                  " class="text-center">
                    <button class="btn btn-danger btn-sm" @click="Eliminar(doc.idDocumento)" title="Eliminar documento">
                      <i class="bi bi-trash3-fill"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- PAGINACIÓN -->
            <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
              <button class="btn btn-outline-primary btn-sm" @click="goToPage(1)" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
              </button>
              <button class="btn btn-outline-primary btn-sm" @click="previousPage" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>
              <span class="pagination-info fw-bold">
                Página {{ currentPage }} de {{ totalPages }}
              </span>
              <button class="btn btn-outline-primary btn-sm" @click="nextPage" :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>
              <button class="btn btn-outline-primary btn-sm" @click="goToPage(totalPages)"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";
// import pdfjsWrapper from 'vue-pdf/src/pdfjsWrapper';
// import PDFJS from 'pdfjs-dist';
// import * as PDFJS from 'pdfjs-dist/build/pdf';
// import 'pdfjs-dist/build/pdf.worker'; // Importar el archivo pdf.worker.js
// import 'pdfjs-dist/build/pdf.worker.entry';

// PDFJS.GlobalWorkerOptions.workerPort = () => new PDFJS.PDFWorker({});

export default {
  name: "SolimanologDatosDocumentos",

  data() {
    return {
      vacio: "",
      loading: false,
      currentPage: 1,
      pageSize: 6,
      filterField: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Postulacion/",
      cerrarTable1: true,
      cerrarTable2: false,

      tipoDoc: "",
      idSolxPostulante: "",
      idUsuario: "",
      isdisabled: false,
      // retro: false,
      // avanzar: true,

      documento: [],
      documentoEscoger: [],
      docPendiente: "",
      selectedFile: null,
      permisoVisualizador: null,
      magnifierPosition: "0px 0px", // Agrega la propiedad magnifierPosition y su valor inicial
      showModal: false,
      showModal2: false,
      currentUrl: "",
      currentUrl2: "",

      isMobile: false,

      //
      idempresa: "1",
      nombre: "",
      dni: "",
      nacionalidad: "",
      nomEmpresa: "",
      loadingVerification: false,
      campana:false
    };
  },

  async mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    this.idSolxPostulante = this.$route.params.idSol;
    const humanos = localStorage.getItem("userId");
    this.idUsuario = humanos;
    console.log(this.idUsuario);

    let listado = await this.axios.get(
      `Documentos/OpcDocumentos?idSolxPostulant=${this.$route.params.idSol}&idUsuario=${humanos}`
    );

    this.documentoEscoger = listado.data;
    console.log('ass',this.documentoEscoger);

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },

  created() {
    this.getAttributes();
    this.atrributesGetters();
    this.cambiarEstadoNavbar();
    this.UsuarioData();
  },

  computed: {
    totalPages() {
      return Math.ceil(this.documento.length / this.pageSize);
    },
    paginatedDocuments() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.documento.slice(start, end);
    },

    fechaActual() {
      const meses = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];
      const f = new Date();
      // Si quieres que siempre sea 2026 como pides:
      const anio = 2026;
      // Si prefieres el año actual real, usa: f.getFullYear()

      return `${f.getDate()} de ${meses[f.getMonth()]} del ${anio}`;
    },
  },

  methods: {
    UsuarioData() {
      this.axios
        .get("Contrato/ObtenerDatosContrato/" + this.$route.params.idSol)
        .then((r) => {
          console.log("data", r.data);

          this.nombre =
            r.data[0].posNombre + ' ' +
            r.data[0].posApellidoPaterno + ' ' +
            r.data[0].posApellidoMaterno;

          this.sisPensiones = r.data[0].sisPensiones;
          this.nomEmpresa = r.data[0].nomEmpresa;
          this.dni = r.data[0].posNroDocumento;
          this.nacionalidad = r.data[0].nomNacionalidad;
          this.idempresa = r.data[0].idEmpresa;
          this.campana = r.data[0].campana
        });
    },

    goToPage(page) {
      this.currentPage = page;
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },
    openModal(url) {
      console.log(url);
      this.showModal = true;
      this.currentUrl = url;
    },

    closeModal() {
      this.showModal = false;
      this.currentUrl = "";
    },

    openModal2(url) {
      console.log(url);
      this.showModal2 = true;
      this.currentUrl2 = url;
    },

    closeModal2() {
      this.showModal2 = false;
      this.currentUrl2 = "";
    },
    async atrributesGetters() {
      const humanos = localStorage.getItem("userId");
      let documentoPendiente = await this.axios.get(
        `Documentos/ValidarDocumentos?idSolxPostulante=${this.$route.params.idSol}&idUsuario=${humanos}`
      );
      this.docPendiente = documentoPendiente.data;
      console.log(documentoPendiente.data);
    },

    async getAttributes() {
      this.loading = true;
      const humanos = localStorage.getItem("userId");
      let doc = await this.axios.get(
        `Documentos/ListarDocxUser?idSolxPostulante=${this.$route.params.idSol}&idUser=${humanos}`
      );
      this.documento = doc.data;
      console.log(doc.data);
      this.loading = false;
    },

    retroceder() {
      window.history.back();
    },

    onFileSelected(event) {
      
      this.selectedFile = event.target.files[0];
      
       console.log(this.selectedFile.name)
    },

    // onUpload(event) {
    //   if(event != '004'){
    //   this.tipoDoc = event.target.value;
    //   }else{
    //   this.tipoDoc = event
    //   }
    //   //  console.log('kk' ,  event , this.tipoDoc);

    //   const fd = new FormData();
    //   fd.append("Archivo", this.selectedFile);
    //   fd.append("tipoDoc", this.tipoDoc);
    //   fd.append("idSolxPostulante", this.idSolxPostulante);
    //   fd.append("IdUsuario", this.idUsuario);

    //   this.axios
    //     .post("Documentos/InsertarDocumento", fd)
    //     .then((r) => {
    //       console.log(r.data);
    //       console.log(this.tipoDoc, this.idSolxPostulante, this.idUsuario);

    //       if (r.data) {
    //         this.tipoDoc = "";
    //         let timerInterval;
    //         Swal.fire({
    //           title: "¡Espere un momento, no cerrar la pantalla!",
    //           html: "<strong>Cargando archivo <b></b> ...</strong>",
    //           timer: 2000,
    //           timerProgressBar: true,
    //           didOpen: () => {
    //             Swal.showLoading();
    //             const b = Swal.getHtmlContainer().querySelector("b");
    //             timerInterval = setInterval(() => {
    //               b.textContent = Swal.getTimerLeft();
    //             }, 450);
    //           },
    //           willClose: () => {
    //             clearInterval(timerInterval);
    //             this.$bvModal.hide('modal-declaracion');
    //           },
    //         }).then((result) => {
    //           /* Read more about handling dismissals below */
    //           if (result.dismiss === Swal.DismissReason.timer) {
    //             this.getAttributes();
    //             this.atrributesGetters();
    //           }
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    // onUpload(event) {
    async onUpload(event) {
      let archivos = [];

      // --- PASO 1: Determinar el tipo de documento y los archivos ---
      if (event === '009') {
        // Caso especial: Autorización de Verificación (viene del PDF generado)
        this.tipoDoc = '009';
        if (this.selectedFile) archivos = [this.selectedFile]; 
      } else {
        // Caso normal: Botones de la tabla
        this.tipoDoc = event; 
        const input = document.getElementById('file-' + event);
        if (input && input.files.length > 0) {
          // Convertimos FileList a Array para poder iterar sobre cada archivo
          archivos = Array.from(input.files);
        }
      }

      // Validación: Si no hay archivos seleccionados
      if (archivos.length === 0) {
        Swal.fire("Aviso", "Por favor, seleccione al menos un archivo antes de cargar.", "warning");
        return;
      }

      // Mostramos un loader global mientras sube todos los archivos
      Swal.fire({
        title: "Subiendo archivos...",
        html: `Procesando <b>${archivos.length}</b> archivo(s). Por favor, no cierre la ventana.`,
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });

      try {
        // --- PASO 2: Enviar archivos (Iteramos para que el backend reciba uno por uno) ---
        for (const archivo of archivos) {
          const fd = new FormData();
          fd.append("Archivo", archivo);
          fd.append("tipoDoc", this.tipoDoc);
          fd.append("idSolxPostulante", this.idSolxPostulante);
          fd.append("IdUsuario", this.idUsuario);
          
          await this.axios.post("Documentos/InsertarDocumento", fd);
        }

        // --- PASO 3: Éxito y Animación Final ---
        this.tipoDoc = "";
        const input = document.getElementById('file-' + event);
        if (input) input.value = ""; // Limpiamos el input visualmente

        let timerInterval;
        await Swal.fire({
          title: "¡Carga Finalizada!",
          html: "Sincronizando información en <b></b> ...",
          timer: 2000,
          timerProgressBar: true,
          didOpen: () => {
            const b = Swal.getHtmlContainer().querySelector("b");
            timerInterval = setInterval(() => { b.textContent = Swal.getTimerLeft(); }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
            this.$bvModal.hide('modal-verificacion'); // Cerramos modal si era la autorización
          },
        });

        this.getAttributes(); // Actualizamos la lista de documentos
        this.atrributesGetters(); // Actualizamos el estado de documentos pendientes

      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Ocurrió un problema al subir uno o más archivos.", "error");
      }
    },

    Eliminar(id) {
      Swal.fire({
        title: "¿Eliminar Documento?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Eliminado!",
            text: "con éxito.",
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
          });
          this.axios.delete("Documentos/Eliminar/" + id).then((r) => {
            console.log(r.data);
            this.getAttributes();
            this.atrributesGetters();
          });
        }
      });
    },

    pdfAbrir(mostrarPdf) {
      console.log(mostrarPdf);
      // var URL =  `file:///C:/`;

      // window.open(URL ,null );

      // console.log(URL)
    },

    async descargarPDF(evento) {
          this.loadingVerification = true;
          const element = this.$refs.documento;
          
          const opt = {
            margin: [1, 1, 1, 1],
            filename: 'declaracion.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
          };

          try {
            // Usamos la sintaxis de Worker para asegurar que outputBlob funcione
            const pdfBlob = await html2pdf()
              .set(opt)
              .from(element)
              .output('blob'); // Aquí está el cambio clave: .output('blob')

            // Ahora lo convertimos a FILE para tu variable selectedFile
            this.selectedFile = new File([pdfBlob], "Declaracion_Jurada.pdf", {
              type: "application/pdf",
              lastModified: new Date().getTime()
            });

            console.log("Archivo guardado con éxito en this.selectedFile" , this.selectedFile);
            // alert("¡PDF listo para cargar!");

            // Aquí ya puedes llamar a tu función de subir si quieres
             await this.onUpload(evento);

          } catch (error) {
            console.error("Error al procesar el PDF:", error);
            // alert("Hubo un problema al generar el archivo.");
          } finally {
            this.loadingVerification = false;
          }

    },

   
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 1%;
  margin-right: 1%;
  height: auto;
  padding-bottom: 20px;
  border-radius: 10px 10px 10px 10px;
  overflow-x: hidden;
  overflow-y: none;
}

.textos {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 700;
  color: #002c5d;
}

.tamaño2 {
  font-size: 0.65rem;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.titulo2 {
  color: #0080c8;
  font-weight: 600;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table {
  background: #0080c8;
}

.pdfview {
  width: 500px;
  height: 400px;
}

.magnifier {
  position: absolute;
  border: 1px solid black;
  pointer-events: none;
}

.modal {
  position: fixed;
  /* top: 0;
  left: 0; */
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 250, 0);
  /* Fondo transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  width: 30%;
  height: 70%;
  background-color: #fff;
}

.modal-content object {
  width: 100%;
  height: 100%;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamañofiltrado {
  font-size: 0.65rem;
}

/* pendientes de documentos pdf */

.document-container {
  background-color: white;
  padding: 1cm;
  /* Margen interno de la hoja */
  margin: 0 auto;
  /* Centrar la hoja en el modal */
  width: 100%;
  /* Que se adapte al ancho del modal-lg */
  max-width: 21cm;
  /* Ancho máximo de una hoja A4 */
  min-height: 18.7cm;
  /* Altura mínima de una hoja A4 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Sombrita para que se note el papel */
  font-family: Arial, sans-serif;
  color: black;
}

.header-logo {
  text-align: right;
  margin-bottom: 10px;
}

.header-logo img {
  width: 120px;
}

.title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  text-decoration: underline;
  margin-bottom: 20px;
}

.content p {
  text-align: justify;
  margin-bottom: 5px;
}

.lista-vulnerabilidad {
  margin-left: 20px;
  margin-bottom: 10px;
}

.firma-container {
  margin-top: 100px;
}

.linea-firma {
  width: 250px;
  border-top: 1px solid black;
  margin: 0 auto 5px auto;
}

.btn-download {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
